module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"search":"Buscar","placeholder":"Buscar por número do pedido","status":"Status"},"en-US":{"search":"Search","placeholder":"Search by order number","status":"Status"}}')
  delete Component.options._Ctor
}
